// import type { VideoProject } from "../types";

// export type UserRole = "admin" | "teacher";
// export type VideoStatus =
//   | "Todo"
//   | "PendingReview"
//   | "InReview"
//   | "Reject"
//   | "Done";

// export type AppUser = {
//   id: string;
//   name: string;
//   role: UserRole;
//   lesson: string;
// };

// export type DashboardVideo = {
//   id: string;
//   title: string;
//   videoUrl: string;
//   status: VideoStatus;
//   updatedAt: string;
//   ownerId: string;
//   ownerName: string;
//   lesson: string;
// };



const USERS_KEY = "interactive-video-builder:users:v1";
const CURRENT_USER_ID_KEY = "interactive-video-builder:current-user-id:v1";
const DASHBOARD_VIDEOS_KEY = "interactive-video-builder:dashboard-videos:v1";
const VIDEO_WORKS_KEY = "interactive-video-builder:video-works:v1";
const STATUS_OVERRIDES_KEY = "interactive-video-builder:status-overrides:v1";

const SEED_USERS = [
  { id: "admin-1", name: "Admin", role: "admin", lesson: "Tüm Dersler" },
  { id: "t-001", name: "Ayşe Öğretmen", role: "teacher", lesson: "Kimya" },
  { id: "t-002", name: "Mehmet Öğretmen", role: "teacher", lesson: "Matematik" }
];

const nowIso = new Date().toISOString();
const SEED_DASHBOARD_VIDEOS = [
  {
    id: "v-001",
    title: "Asit Baz Dengesi",
    videoUrl:
      "https://d2cqobm8wcb2vo.cloudfront.net/compressedachievementvideos/101010103_1.mp4",
    status: "Todo",
    updatedAt: nowIso,
    ownerId: "t-001",
    ownerName: "Ayşe Öğretmen",
    lesson: "Kimya"
  },
  {
    id: "v-002",
    title: "Mol Kavramı",
    videoUrl:
      "https://d2cqobm8wcb2vo.cloudfront.net/compressedachievementvideos/101010103_1.mp4",
    status: "PendingReview",
    updatedAt: nowIso,
    ownerId: "t-001",
    ownerName: "Ayşe Öğretmen",
    lesson: "Kimya"
  },
  {
    id: "v-003",
    title: "Kök İçeren Denklemler",
    videoUrl:
      "https://d2cqobm8wcb2vo.cloudfront.net/compressedachievementvideos/101010103_1.mp4",
    status: "InReview",
    updatedAt: nowIso,
    ownerId: "t-002",
    ownerName: "Mehmet Öğretmen",
    lesson: "Matematik"
  },
  {
    id: "v-004",
    title: "Fonksiyonlar - Soru Çözümü",
    videoUrl:
      "https://d2cqobm8wcb2vo.cloudfront.net/compressedachievementvideos/101010103_1.mp4",
    status: "Reject",
    updatedAt: nowIso,
    ownerId: "t-002",
    ownerName: "Mehmet Öğretmen",
    lesson: "Matematik"
  },
  {
    id: "v-005",
    title: "Organik Kimya Giriş",
    videoUrl:
      "https://d2cqobm8wcb2vo.cloudfront.net/compressedachievementvideos/101010103_1.mp4",
    status: "Done",
    updatedAt: nowIso,
    ownerId: "t-001",
    ownerName: "Ayşe Öğretmen",
    lesson: "Kimya"
  }
];

function safeParse(value) {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function ensureSeedData() {
  if (typeof window === "undefined") {
    return;
  }
  const users = safeParse(window.localStorage.getItem(USERS_KEY));
  if (!users || users.length === 0) {
    window.localStorage.setItem(USERS_KEY, JSON.stringify(SEED_USERS));
  }
  const videos = safeParse(
    window.localStorage.getItem(DASHBOARD_VIDEOS_KEY)
  );
  if (!videos || videos.length === 0) {
    window.localStorage.setItem(
      DASHBOARD_VIDEOS_KEY,
      JSON.stringify(SEED_DASHBOARD_VIDEOS)
    );
  }
}

function listBaseDashboardVideos() {
  if (typeof window === "undefined") {
    return SEED_DASHBOARD_VIDEOS;
  }
  ensureSeedData();
  return (
    safeParse(window.localStorage.getItem(DASHBOARD_VIDEOS_KEY)) ??
    []
  );
}

function listVideoWorks(){
  if (typeof window === "undefined") {
    return [];
  }
  return safeParse(window.localStorage.getItem(VIDEO_WORKS_KEY)) ?? [];
}

function saveVideoWorks(records) {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(VIDEO_WORKS_KEY, JSON.stringify(records));
}

function getStatusOverrides() {
  if (typeof window === "undefined") {
    return {};
  }
  return (
    safeParse<Record<string, VideoStatus>>(
      window.localStorage.getItem(STATUS_OVERRIDES_KEY)
    ) ?? {}
  );
}

function saveStatusOverride(videoId ,status) {
  if (typeof window === "undefined") {
    return;
  }
  const next = { ...getStatusOverrides(), [videoId]: status };
  window.localStorage.setItem(STATUS_OVERRIDES_KEY, JSON.stringify(next));
}

function mergeStatus(video) {
  const overrides = getStatusOverrides();
  const override = overrides[video.id];
  if (!override) {
    return video;
  }
  return { ...video, status: override };
}

function canEditByStatus(status) {
  return status !== "InReview" && status !== "Approve";
}

function canEditByStatusForAdmin(status) {
    return status !== "Todo" && status !== "Approve" && status !== "Reject";
  }

function nextStatusAfterSave(currentStatus) {
  if (currentStatus === "Todo" || currentStatus === "Reject") {
    return "PendingReview";
  }
  return currentStatus;
}

export function getUsers() {
  if (typeof window === "undefined") {
    return SEED_USERS;
  }
  ensureSeedData();
  const existing = safeParse(window.localStorage.getItem(USERS_KEY));
  return existing && existing.length > 0 ? existing : SEED_USERS;
}

export function getCurrentUser() {
  const users = getUsers();
  if (typeof window === "undefined") {
    return users[1] ?? users[0];
  }
  const currentId = window.localStorage.getItem(CURRENT_USER_ID_KEY);
  const user = users.find((item) => item.id === currentId);
  if (user) {
    return user;
  }
  const fallback = users[1] ?? users[0];
  if (fallback) {
    window.localStorage.setItem(CURRENT_USER_ID_KEY, fallback.id);
    return fallback;
  }
  return { id: "anonymous", name: "Öğretmen", role: "teacher", lesson: "-" };
}

export function setCurrentUserId(userId){
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(CURRENT_USER_ID_KEY, userId);
}

export async function fetchDashboardVideos(
  user
) {
  const all = listBaseDashboardVideos().map(mergeStatus);
  const visible =
    user.role === "admin" ? all : all.filter((item) => item.ownerId === user.id);
  return visible.sort((a, b) => b.updatedAt.localeCompare(a.updatedAt));
}

export async function getDashboardVideoById(
  id
) {
  const found = listBaseDashboardVideos().map(mergeStatus).find((v) => v.id === id);
  return found ?? null;
}

export function getVideoProjectByVideoId(videoId) {
  const record = listVideoWorks().find((item) => item.videoId === videoId);
  return record?.project ?? null;
}

export function saveVideoWork(params) {
  const works = listVideoWorks();
  const now = new Date().toISOString();
  const project = {
    ...params.project,
    title: params.project.title.trim() || params.video.title,
    videoUrl: params.video.videoUrl
  };

  const nextRecord = {
    videoId: params.video.id,
    ownerId: params.user.id,
    updatedAt: now,
    project
  };
  const nextWorks = works.some((item) => item.videoId === params.video.id)
    ? works.map((item) => (item.videoId === params.video.id ? nextRecord : item))
    : [nextRecord, ...works];
  saveVideoWorks(nextWorks);

  const nextStatus = nextStatusAfterSave(params.video.status);
  if (nextStatus !== params.video.status) {
    saveStatusOverride(params.video.id, nextStatus);
  }

  return { videoId: params.video.id, status: nextStatus, project };
}

export function getStatusActionForAdmin(status) {
    if (!canEditByStatusForAdmin(status)) {
      if(status === "Approve"){
        return {
          label: status === "Approve" ? "Tamamlandı" : "İncele",
          disabled: true
        }
      }else{

      return {
        label: status === "Todo" ? "Ekle" : "Düzenle",
        disabled: true
      };
    }

    }
    return {
      label: status === "Approve" ? "Tamamlandı" : "İncele",
      disabled: false
    };
  }

export function getStatusAction(status) {
  if (!canEditByStatus(status)) {
    return {
      label: status === "Approve" ? "Tamamlandı" : "İncelemede",
      disabled: true
    };
  }
  return {
    label: status === "Todo" ? "Ekle" : "Düzenle",
    disabled: false
  };
}

export function getStatusLabel(status) {
  if (status === "Todo") return "Yapılacak";
  if (status === "PendingReview") return "İnceleme Bekleniyor";
  if (status === "InReview") return "İncelemede";
  if (status === "Reject") return "Reddedildi";
  if (status === "HasError") return "Hatalı";
  return "Tamamlandı";
}